import { useState, useEffect, useRef } from "react";

import {
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
  CCardFooter,
  CLink,
  CPagination,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import Statistics from "../Show/statistics";
import "./styles.css";

const ClassroomMe = props => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statistics, setStatistics] = useState(false);
  const [statisticsName, setStatisticsName] = useState("");
  const [classroomsListPage, setClassroomsListPage] = useState(1);
  const [classroomsListLastPage, setClassroomsListLastPage] = useState(1);
  const [yearSelected, setYearSelected] = useState();

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      pullClassrooms(classroomsListPage);
    }
  }, [yearSelected, classroomsListPage]);

  const newInfo = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.info("Aviso", response);
    }
  };

  const pullClassrooms = async page => {
    const currYear = new Date().getFullYear();

    try {
      const classroomResponse = await axios.get(
        `${URL.api}community/room_user/listRoomsByUser?page=${
          page || 1
        }&page_size=28`,
        {
          params: {
            start: `${yearSelected ?? currYear}-01-01`,
            end: `${yearSelected ?? currYear}-12-31`
          },
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      setRooms(classroomResponse.data.data);
      setLoading(false);
      setClassroomsListPage(classroomResponse.data.meta.current_page);
      setClassroomsListLastPage(classroomResponse.data.meta.last_page);
    } catch (info) {
      newInfo("Você não está participando de nenhuma turma nesse ano!");

      setRooms([]);
      setLoading(false);
      setClassroomsListPage(1);
      setClassroomsListLastPage(1);
    }
  };

  useEffect(() => {
    // let requestRoute;

    // let roomDisciplines = false;

    // if (props.user.user_roles[0].role_id === 4) {
    //   // Adm escolar
    //   requestRoute = `${URL.api}community/room/list?class=true&room_disciplines=${roomDisciplines}&school[]=${props.user.user_roles[0].school_id}`;
    // } else if (props.user.user_roles[0].role_id === 2) {
    //   // Adm de grupo
    //   requestRoute = `${URL.api}community/room/list?class=true&room_disciplines=${roomDisciplines}&group[]=${props.user.user_roles[0].group_id}`;
    // } else if (props.user.user_roles[0].role_id === 3) {
    //   // Adm regional
    //   requestRoute = `${URL.api}community/room/list?class=true&room_disciplines=${roomDisciplines}&region[]=${props.user.user_roles[0].region_id}`;
    // } else {
    //   // Demais usuários
    //   requestRoute = `${URL.api}community/room/listByUser?class=true&room_disciplines=${roomDisciplines}&user=${props.user.user.id}`;
    // }

    props.setObj(16, props.currentRoute, props.currentRoute);
    const currYear = new Date().getFullYear();
    setYearSelected(currYear);
  }, []);

  return (
    <>
      <Breadcrumb current={props.currentRoute} />
      {loading ? (
        <Loading top="45" left="50" />
      ) : (
        <>
          {!!statistics && (
            <Statistics
              show
              onClose={() => setStatistics(false)}
              room_id={statistics}
              name={statisticsName}
            />
          )}
          <CCard>
            <CCardHeader className="d-flex align-items-center justify-content-around">
              <CRow className="w-100 d-flex align-items-center">
                <CCol md="10">
                  <div>
                    <h4 className="card-title mb-1">Turmas</h4>
                    <div className="small text-muted">
                      Veja as turmas que você participa
                    </div>
                  </div>
                </CCol>
                <CCol md="2">
                  <CSelect
                    value={yearSelected}
                    onChange={e => {
                      setYearSelected(Number.parseInt(e.target.value));
                    }}
                  >
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </CSelect>
                </CCol>
              </CRow>
            </CCardHeader>
            <CCardBody className="pb-1">
              <CRow>
                {rooms.length > 0 ? (
                  rooms.map((room, idx) => (
                    <CCol sm="4" lg="3" className="mb-3" key={idx}>
                      <CLink
                        to={`/classroom/${room.id}`}
                        className="text-decoration-none"
                      >
                        <CCard className="card-room">
                          <CCardHeader
                            className="bg-primary d-flex justify-content-end flex-column"
                            style={{ height: "120px" }}
                          >
                            <h4
                              className="card-title text-white mb-2 text-ellipsis"
                              title={room.name}
                            >
                              {room.name}
                            </h4>
                            <div
                              className="small text-ellipsis"
                              style={{ opacity: 0.6 }}
                            >
                              {room.external_id && (
                                <>
                                  <i className="fa fa-graduation-cap mr-2"></i>
                                  {room.external_id}

                                  <span
                                    className="mx-2"
                                    style={{ opacity: 0.4 }}
                                  >
                                    ·
                                  </span>
                                </>
                              )}
                              <i className="fa fa-university mr-2"></i>
                              {room.school_name}
                            </div>
                          </CCardHeader>
                          <CCardFooter className="d-flex text-muted">
                            <span className="mr-3" style={{ flex: 1 }}>
                              <i className="fa fa-user mr-2"></i>{" "}
                              {room.num_users}
                            </span>
                            {!["A", "S", "V"].includes(
                              props.general.active_roles.type
                            ) && (
                              <CLink
                                className="mr-3"
                                to="#"
                                onClick={() => {
                                  setStatistics(room.id);
                                  setStatisticsName(room.name);
                                }}
                              >
                                <i className="fa fa-pie-chart text-muted card-icon"></i>
                              </CLink>
                            )}
                            <CLink
                              className="mr-3"
                              to={`/classroom/${room.id}/activities`}
                            >
                              <i className="fa fa-check-square text-muted card-icon"></i>
                            </CLink>
                            <CLink to={`/classroom/${room.id}/docs`}>
                              <i className="fa fa-folder text-muted card-icon"></i>
                            </CLink>
                          </CCardFooter>
                        </CCard>
                      </CLink>
                    </CCol>
                  ))
                ) : (
                  <div className="p-3 text-center w-100 text-muted mb-3">
                    Você não está participando de nenhuma turma
                  </div>
                )}
              </CRow>
            </CCardBody>
            <CCardFooter className="pb-0">
              <CPagination
                align="end"
                className="mt-1"
                activePage={classroomsListPage}
                pages={classroomsListLastPage}
                onActivePageChange={page => setClassroomsListPage(page)}
              />
            </CCardFooter>
          </CCard>
        </>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomMe);
